import { GxForm, GxIcon } from '@garpix/garpix-web-components-react'
import IconButton from '@/components/Button/IconButton'
import Checkbox from '@/components/Checkbox'
import Input from '@/components/Input'
import { Select, SelectItem } from '@/components/Select'
import { searchIcon } from '@/images'
import React, { useState } from 'react'
import style from '../styles/cabinet_championship.module.scss'
import { TypeLoadData } from '@/interfaces/Fetcher'

interface IProps {
  handleFilter: TypeLoadData
  initFilters: any
}

const Filters = ({ handleFilter, initFilters }: IProps): React.ReactElement => {
  const [filter, setFilter] = useState({
    q: undefined,
    version: undefined,
    status: '',
    page_size: initFilters.page_size
  })

  const handleVersionChange = (e): void => {
    const newFiltes = { ...filter, version: e.target.value }
    setFilter(newFiltes)
    handleFilter(1, newFiltes)
  }

  const handleStatus = (e): void => {
    const checked = e.target.checked
    const newFiltes = { ...filter, status: checked === true ? 'open' : '' }
    setFilter(newFiltes)
    handleFilter(1, newFiltes)
  }

  const inputSearch = (e): void => setFilter({ ...filter, q: e.target.value })

  const onSubmit = (): void => handleFilter(1, filter)

  return (
    <GxForm onGx-submit={onSubmit}>
      <div className={style.filters}>
        <Input
          onGx-input={inputSearch}
          type='text'
          placeholder='Поиск...'
          className={style.filters__input}
        >
          <IconButton
            type='submit'
            theme='red'
            size='medium'
            slot='suffix'
            className={style.filters__button}
          >
            <GxIcon src={searchIcon} className={style.filters__button_icon} />
          </IconButton>
        </Input>
        <Select
          onGx-change={handleVersionChange}
          placeholder='Выбери игру'
          className={style.filters__select}
        >
          <SelectItem value='1'>Урбанистика</SelectItem>
          <SelectItem value='2'>Чистый город</SelectItem>
          <SelectItem value='3'>Квартал</SelectItem>
          <SelectItem value='4'>Дом</SelectItem>
          <SelectItem value='5'>Квартира</SelectItem>
        </Select>
        <Checkbox
          onGx-change={handleStatus}
          checked={filter.status === 'open'}
          className={style.filters__checkbox}
        >
          Активные чемпионаты
        </Checkbox>
      </div>
    </GxForm>
  )
}

export { Filters }
